import SportEventMapper from './sport-event-mapper';
import EventCompetitorsModel from '../event-competitors/event-competitors-model';
import LiveModel from '../live/live-model';
import MarketModel from '../market/market-model';

const SportEventModel = {
    mapper: SportEventMapper,

    booked: {
        type: Boolean,
    },

    categoryName: {
        type: String,
    },

    countryCode: {
        type: String,
    },

    currentSeasonId: {
        type: String,
    },

    favorite: {
        fieldName: 'h',
        type: Boolean,
    },

    id: {
        fieldName: 'i',
        type: String,
    },

    leagueName: {
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    liveStatistics: {
        fieldName: 'a',
        model: LiveModel,
        type: Object,
    },

    markets: {
        fieldName: 'm',
        modelContext: {
            eventId: 'id',
        },
        model: MarketModel,
        type: Array,
    },

    mbn: {
        fieldName: 'b',
        type: Number,
    },

    moreMarkets: {
        fieldName: 'k',
        type: Number,
    },

    programCode: {
        fieldName: 'p',
        type: String,
    },

    seasonRefId: {
        type: String,
    },

    sportTypeRefId: {
        fieldName: 's',
        type: String,
    },

    startedAt: {
        fieldName: 'd',
        type: Number,
    },

    teams: {
        fieldName: 't',
        model: EventCompetitorsModel,
        type: Object,
    },
};

export default SportEventModel;
